
import { defineComponent } from "vue";
import { provideStore } from "@/store/store";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default defineComponent({
  name: "App",
  components: {
    Header,
    Footer
  },
  setup() {
    //make our store globally available
    provideStore();
  }
});
